<div class="cellWrapper">
    {{ reportTypeTranslationMap[$any(data).reportName] | translate }}
</div>
